export const mockSupplierInvoices = [
  {
    id: 1,
    numeroFacture: 'FACT-2024-001',
    numeroFactureFournisseur: 'TS-INV-2024-0156',
    fournisseur: 'TechSupply France',
    fournisseurId: 1,
    dateFacture: '2024-01-15',
    dateEcheance: '2024-02-14',
    montantHT: 2400.00,
    montantTTC: 2880.00,
    tva: 480.00,
    devise: 'EUR',
    statut: 'En Attente de Paiement',
    conditionsPaiement: '30 jours',
    bonsReception: ['BR-2024-001', 'BR-2024-002'],
    bonsCommande: ['BC-2024-001'],
    ecartsTarifaires: [
      {
        produit: 'Dell XPS 15',
        prixCommande: 1200.00,
        prixFacture: 1250.00,
        ecart: 50.00,
        motif: 'Augmentation tarifaire'
      }
    ],
    reglements: [],
    montantRegle: 0.00,
    montantRestant: 2880.00,
    alerteEcheance: true,
    joursAvantEcheance: 5
  },
  {
    id: 2,
    numeroFacture: 'FACT-2024-002',
    numeroFactureFournisseur: 'EM-2024-0089',
    fournisseur: 'Électronique Moderne',
    fournisseurId: 2,
    dateFacture: '2024-01-10',
    dateEcheance: '2024-01-25',
    montantHT: 1500.00,
    montantTTC: 1800.00,
    tva: 300.00,
    devise: 'EUR',
    statut: 'Payée Partiellement',
    conditionsPaiement: '15 jours',
    bonsReception: ['BR-2024-003'],
    bonsCommande: ['BC-2024-002'],
    ecartsTarifaires: [],
    reglements: [
      {
        id: 1,
        date: '2024-01-20',
        montant: 900.00,
        modePaiement: 'Virement',
        reference: 'VIR-2024-001',
        notes: 'Paiement partiel - 50%'
      }
    ],
    montantRegle: 900.00,
    montantRestant: 900.00,
    alerteEcheance: true,
    joursAvantEcheance: -5 // En retard
  },
  {
    id: 3,
    numeroFacture: 'FACT-2024-003',
    numeroFactureFournisseur: 'BP-INV-2024-0234',
    fournisseur: 'Bureau Plus',
    fournisseurId: 3,
    dateFacture: '2024-01-08',
    dateEcheance: '2024-01-23',
    montantHT: 850.00,
    montantTTC: 1020.00,
    tva: 170.00,
    devise: 'EUR',
    statut: 'Soldée',
    conditionsPaiement: '15 jours',
    bonsReception: ['BR-2024-004'],
    bonsCommande: ['BC-2024-003'],
    ecartsTarifaires: [],
    reglements: [
      {
        id: 2,
        date: '2024-01-18',
        montant: 1020.00,
        modePaiement: 'Chèque',
        reference: 'CHQ-2024-001',
        notes: 'Paiement intégral'
      }
    ],
    montantRegle: 1020.00,
    montantRestant: 0.00,
    alerteEcheance: false,
    joursAvantEcheance: 0
  },
  {
    id: 4,
    numeroFacture: 'FACT-2024-004',
    numeroFactureFournisseur: 'TS-INV-2024-0157',
    fournisseur: 'TechSupply France',
    fournisseurId: 1,
    dateFacture: '2024-01-20',
    dateEcheance: '2024-02-19',
    montantHT: 3200.00,
    montantTTC: 3840.00,
    tva: 640.00,
    devise: 'EUR',
    statut: 'En Attente de Paiement',
    conditionsPaiement: '30 jours',
    bonsReception: ['BR-2024-005', 'BR-2024-006'],
    bonsCommande: ['BC-2024-004', 'BC-2024-005'],
    ecartsTarifaires: [
      {
        produit: 'Écran Dell 27" 4K',
        prixCommande: 450.00,
        prixFacture: 465.00,
        ecart: 15.00,
        motif: 'Frais de transport'
      }
    ],
    reglements: [],
    montantRegle: 0.00,
    montantRestant: 3840.00,
    alerteEcheance: true,
    joursAvantEcheance: 10
  },
  {
    id: 5,
    numeroFacture: 'FACT-2024-005',
    numeroFactureFournisseur: 'EM-2024-0090',
    fournisseur: 'Électronique Moderne',
    fournisseurId: 2,
    dateFacture: '2024-01-12',
    dateEcheance: '2024-01-27',
    montantHT: 950.00,
    montantTTC: 1140.00,
    tva: 190.00,
    devise: 'EUR',
    statut: 'En Attente de Paiement',
    conditionsPaiement: '15 jours',
    bonsReception: ['BR-2024-007'],
    bonsCommande: ['BC-2024-006'],
    ecartsTarifaires: [],
    reglements: [],
    montantRegle: 0.00,
    montantRestant: 1140.00,
    alerteEcheance: true,
    joursAvantEcheance: -3 // En retard
  },
  {
    id: 6,
    numeroFacture: 'FACT-2024-006',
    numeroFactureFournisseur: 'BP-INV-2024-0235',
    fournisseur: 'Bureau Plus',
    fournisseurId: 3,
    dateFacture: '2024-01-25',
    dateEcheance: '2024-02-24',
    montantHT: 1200.00,
    montantTTC: 1440.00,
    tva: 240.00,
    devise: 'EUR',
    statut: 'En Attente de Paiement',
    conditionsPaiement: '30 jours',
    bonsReception: ['BR-2024-008'],
    bonsCommande: ['BC-2024-007'],
    ecartsTarifaires: [],
    reglements: [],
    montantRegle: 0.00,
    montantRestant: 1440.00,
    alerteEcheance: true,
    joursAvantEcheance: 15
  }
];

export const mockPaymentMethods = [
  { id: 'VIREMENT', label: 'Virement bancaire' },
  { id: 'CHEQUE', label: 'Chèque' },
  { id: 'ESPECES', label: 'Espèces' }
];